import './libs/modernizr.js';
import './libs/bootstrap';


// JS class helper
var body = document.querySelector('body');
body.classList.add('js');

// To top body class helper
window.onscroll = function(e) {
    if (window.pageYOffset > 500) {
        body.classList.add('show-to-top');
    } else {
        body.classList.remove('show-to-top');
    }
};

// Touch body class helper
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    body.classList.add('touch');
}

require('./modules/headroom')
require('./modules/lazy-load')
require('./modules/slider')
require('./modules/gridderjs')
require('./modules/gridder')
require('./modules/map')
require('./modules/ajax-form-handler')
require('./modules/aos')
// require('./modules/ajax-posts')
require('./modules/testimonial')
require('./modules/eventform_datepicker')
require('./modules/mobile')
require('./modules/custom')


function submitRentalForm() {

alert('sending');

}



jQuery(document).ready(function($) {

console.log("FRDBG");

    $('#supply-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#supplybtntxt').toggle();
        });

    $('#wasser-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#wasserbtntxt').toggle();
        });

    $("#select-tarif").click(function(){
            // $('#tarif-result').toggle();
            getTariff();
        });

    $(".ctype").click(function(){
//console.log(this);
	    if (this.className.indexOf('priv') > 0) {
//alert('priv');
		$('#ctype_priv').addClass('selected');
		$('#ctype_busi').removeClass('selected');
		$('#customer_type').val('PRIVATE');
            } else {
                $('#ctype_busi').addClass('selected');
                $('#ctype_priv').removeClass('selected');
		$('#customer_type').val('BUSINESS');
            }
        });


    $(".personinhouse").click(function(){
        
        var pb = [];
        pb[1] = "0";
        pb[2] = "40%";
        pb[3] = "70%";
        pb[4] = "100%";


        var pa = [];
        pa[1] = "0";
        pa[2] = "30%";
        pa[3] = "60%";
        pa[4] = "90%";

        var personnum = this.dataset.val;
        var data_val = this.dataset.value;
        $('.personinhouse').removeClass('selected');
        for (let index = 1; index <= personnum; index++) {
            $(".progress"+index).addClass('selected');   
        }

        $(".profileprogress_baractive").css("width",pb[personnum]);
        $(".profileprogress_active").css("left",pa[personnum]);

        $("#personinhouse_value").val(data_val);
    });

});



let tariffs = [];

function getTariff(url) {
  console.log(document.getElementById("tarif-result").style.display);
  //console.log(document.getElementById("tarif-result").style);

  if (document.getElementById("tarif-result").style.display != 'block') {

// postleitzahl, verbrauch, personinhouse_value
//if (tariffs.length < 1) {

    var data = {
      action: "tariff_call",
      my_input: "some_value tariff"
    };
    jQuery.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: "action=" + data.action + "&my_input=" + data.my_input + "&verbrauch=" + document.getElementById("verbrauch").value + "&customer_type=" + document.getElementById("customer_type").value,
      success: function success(response) {
        console.log('Response:', response);
        var jsonObject = JSON.parse(response);
        tariffs = jsonObject.tariffs;

        // console.log('Object value:', jsonObject.systemOperator);
        console.log('Object value:', tariffs);

        alert('get form' + tariffs.length);

        let contEl = document.getElementById("tariff_calculator_form");
        //  let html_cont = "";

        console.log("Tarife: " + tariffs.length);

//      if (tariffs.length < 1)
//              return;

        let html = contEl.innerHTML;

        for (var i=0; i<tariffs.length; i++) {

                console.log(i);

        // add tariff html
                // in  div tariff_calculator_form
                html = html + '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus</h3><div class="tarif-price">monatlich ca. <span class="tarif-pricetext" style="color:#E94E1B">44,46</span> ct/kWh</div><div class="tarif-content"><ul><li>Arbeitspreis ab 30,84 ct*</li><li>Grundpreis ab 4,73 €*</li><li>Kündigungsfrist 2 Wochen</li></ul><p><button class="tariff-btn">Traif buchen</button></p></div></div></div>';

// '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus</h3><div class="tarif-price">monatli$

// '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus</h3><div class="tarif-price">monatli$';

        // refill data

        }

        contEl.innerHTML = html;        

        jQuery('#tarif-result').toggle();
      } // function success
    }); // end ajax


//} // tarrifs length - already loaded


  } else jQuery('#tarif-result').toggle();

alert("OK");

}


function getTariff1(url) {

console.log(document.getElementById("tarif-result").style.display);
//console.log(document.getElementById("tarif-result").style);

	if (document.getElementById("tarif-result").style.display != 'block') {


		var data = {
			action: "tariff_call",
			my_input: "some_value tariff"
		};


		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: "action=" + data.action + "&my_input=" + data.my_input,
			success: function(response) {
				console.log('Response:', response);
				const jsonObject = JSON.parse(response);
				console.log('Object value:', jsonObject.systemOperator);

				jQuery('#tarif-result').toggle();
			}
		});


	} else

	        jQuery('#tarif-result').toggle();

}



function setCustomerType(typeStr) {
alert("OK");
/*
        if (!typeStr) {
                document.getElementById('ctype_busi').class = '';
                document.getElementById('ctype_priv').class = 'selected';
                document.getElementById('customer_type').value = 'PRIVATE';
        } else {
                document.getElementById('ctype_busi').class = 'selected';
                document.getElementById('ctype_priv').class = '';
                document.getElementById('customer_type').value = 'BUSINESS';
        }
//      document.getElementById('customer_type').value = typeStr;
//id="ctype_busi" class="selected" onclick="setCustomerType('BUSINESS');">Gewerb
*/
}



